import React, { useCallback, startTransition } from 'react';
import { Tag } from '@douyinfe/semi-ui';
import { IconClose } from '@douyinfe/semi-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import useStore from 'src/store';
import { useLocale } from '../../../../locales';
import useFinanceStore from '@/views/finance/store';
import './index.scss';

const TabBar: React.FC = () => {
  const { tabList, setTabList } = useStore();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { formatMessage } = useLocale();

  const handleClick = useCallback(
    (itemKey: string) => {
      if (itemKey !== pathname) {
        startTransition(() => {
          navigate(itemKey);
        });
      }
    },
    [pathname, navigate]
  );

  const handleClose = useCallback(
    (e: React.MouseEvent, itemKey: string) => {
      e.stopPropagation();
      const idx = tabList.findIndex((t) => t.itemKey === itemKey);
      if (idx < 0) return;

      const newTabs = tabList.filter((t) => t.itemKey !== itemKey);
      setTabList(newTabs);

      // 关闭 tab 时重置对应页面的 store 缓存
      if (itemKey === '/finance') {
        useFinanceStore.getState().reset();
      }

      if (itemKey === pathname && newTabs.length > 0) {
        const nextIdx = Math.min(idx, newTabs.length - 1);
        startTransition(() => {
          navigate(newTabs[nextIdx].itemKey);
        });
      }
    },
    [tabList, setTabList, pathname, navigate]
  );

  if (tabList.length === 0) return null;

  return (
    <div className='tab-bar'>
      <div className='tab-bar__list'>
        {tabList.map((tab) => {
          const isActive = pathname === tab.itemKey;
          const label = formatMessage({ id: tab.tab });
          return (
            <div
              key={tab.itemKey}
              className={`tab-bar__item ${
                isActive ? 'tab-bar__item--active' : ''
              }`}
              onClick={() => handleClick(tab.itemKey)}
            >
              <span className='tab-bar__label'>{label}</span>
              {tab.closable !== false && tab.itemKey !== '/dashboard' && (
                <IconClose
                  className='tab-bar__close'
                  size='small'
                  onClick={(e) => handleClose(e, tab.itemKey)}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TabBar;
